

































































































import {Component, Vue} from "vue-property-decorator";
import {namespace} from 'vuex-class';

const shardsStore = namespace('shards')
const profileStore = namespace('profile')


@Component
export default class FiltersIndex extends Vue {
  protected type: any = ''
  protected typeFio: any = ''
  @shardsStore.Getter('GetShards') protected GetShards: any
  @shardsStore.Getter('GetFilterShards') protected FilterShards: any
  @shardsStore.Getter('GetCountFiltersShards') protected GetCountFiltersShards: any

  @shardsStore.Mutation('setFilterShards') protected setFilterShards: any
  @shardsStore.Mutation('clearFilterShards') protected clearFilterShards: any

  @profileStore.Getter('profilesMap') protected profiles:any



}
